import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod/v4";

export const updateProductFamilyListing = {
  name: "updateProductFamilyListing" as const,
  input: z.object({
    channel: ChannelSchema,
    listingId: z.string(),
    title: z.string().optional(),
    sku: z.string().optional(),
    description: z.string().optional(),
    price: z.number().optional(),
    compareAtPrice: z.number().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    syncedToChannel: z.boolean(),
  }),
};
